import React from 'react';
import LegalLayout from '../components/Legal';
import { COMPANY, ADDRESS_FULL } from '../siteData';
import {
  LegalTitle,
  LegalUpdated,
  LegalH2,
  LegalP,
  LegalA,
} from '../components/Legal/LegalElements';

const TermsPage = () => {
  return (
    <LegalLayout>
      <LegalTitle>Terms of Use</LegalTitle>
      <LegalUpdated>Last updated: June 25, 2026</LegalUpdated>

      <LegalP>
        {`These Terms govern your access to and use of Repatch (the "Service"), an AI voice receptionist operated by Cloutch LLC ("Repatch," "we").`}
      </LegalP>
      <LegalP>
        {`By accessing or using the Service, you agree to these Terms. If you do not agree, do not use the Service.`}
      </LegalP>

      <LegalH2>Use of the Service</LegalH2>
      <LegalP>
        {`You may use the Service only in compliance with these Terms and all applicable laws. You are responsible for the accuracy of the information you provide and for all activity that occurs under your account.`}
      </LegalP>

      <LegalH2>Text messaging (SMS)</LegalH2>
      <LegalP>
        {`If you enable text messaging, you authorize Repatch to send SMS on your behalf to callers who contact your business, and you are responsible for ensuring those messages comply with the TCPA, CTIA guidelines, and A2P 10DLC requirements. Messages are transactional — appointment confirmations, reschedule and cancellation notices, requested information, and missed-call follow-ups. Message frequency varies based on call activity, and message and data rates may apply. Recipients can reply STOP at any time to unsubscribe and HELP for assistance; the Service honors these requests automatically.`}
      </LegalP>

      <LegalH2>Your responsibilities</LegalH2>
      <LegalP>
        {`You represent that you have obtained any consents required to communicate with the callers and customers you direct to the Service, and that your use of the Service does not violate the rights of any third party.`}
      </LegalP>

      <LegalH2>Intellectual property</LegalH2>
      <LegalP>
        {`The Service, including its software, content, and trademarks, is owned by ${COMPANY.legalName} and its licensors and is protected by applicable laws. These Terms do not grant you any right to our intellectual property except as necessary to use the Service.`}
      </LegalP>

      <LegalH2>Disclaimers and limitation of liability</LegalH2>
      <LegalP>
        {`The Service is provided "as is" and "as available" without warranties of any kind, to the fullest extent permitted by law. To the maximum extent permitted by law, ${COMPANY.legalName} will not be liable for any indirect, incidental, or consequential damages arising out of your use of the Service.`}
      </LegalP>

      <LegalH2>Changes to these Terms</LegalH2>
      <LegalP>
        {`We may update these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.`}
      </LegalP>

      <LegalH2>Contact us</LegalH2>
      <LegalP>
        {`The Service is operated by ${COMPANY.legalName}. If you have questions about these Terms, contact us at `}
        <LegalA href={`mailto:${COMPANY.email}`}>{COMPANY.email}</LegalA>
        {` or by mail at ${ADDRESS_FULL}.`}
      </LegalP>
    </LegalLayout>
  );
};

export default TermsPage;
